module.exports = __webpack_public_path__ + "img/4-2.84f7e70c.png";